<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Detalle de Boleta de Visita</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número de Boleta: </span> {{visitTicket.Name}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha-Hora de Entrada: </span>
									{{visitTicket.CheckInDate|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha-Hora de Salida: </span>
									{{visitTicket.CheckOutDate|dateFormatFull}}</h6>
							</b-col>

							<b-col md="12" lg="12" class="mt-3 text-justify">
								<h6><span class="text-info">Trabajos Realizados: </span> {{visitTicket.Activity}}</h6>
							</b-col>
						</b-row>

						<!-- <b-row class="mt-4">
							<b-col md="12" lg="12">
								<h6 class="text-info border-bottom border-info">Reportes</h6>
							</b-col>

							<b-col v-if="!reportsLoader" v-for="report in reports" md="4" lg="3">
								<b-button @click="downloadFile(report)" variant="link" class="d-flex">
									<span class="mr-1 text-dark">{{report.FileName}}</span>
									<i class="fa fa-download fa-2x" aria-hidden="true"></i>
								</b-button>
							</b-col>
							<b-col v-if="reportsLoader" md="12" lg="12" class="d-flex justify-content-center">
								<b-spinner variant="primary" label="Spinning"></b-spinner>
							</b-col>
							<b-col v-if="!reportsLoader && reports.length === 0" md="12" lg="12"
								   class="d-flex justify-content-center text-danger">
								<h6>No hay reportes disponibles</h6>
							</b-col>
						</b-row> -->

						<b-row class="mt-4 justify-content-around">
							<b-col md="12" lg="12" class="mb-3">
								<h6 class="text-info border-bottom border-info">Adjuntos, Imagenes u Otros.</h6>
							</b-col>

							<b-col v-if="!reportsLoader" v-for="attachment in attachments" md="4" lg="3">
								<b-img v-bind:src="'data:image/jpeg;base64,'+ attachment.DocumentBody"
									   fluid thumbnail></b-img>
								<b-button @click="downloadAttachment(attachment)" variant="link" class="d-flex">
									<span class="mr-1 text-dark">{{attachment.FileName}}</span>
									<i class="fa fa-download fa-2x" aria-hidden="true"></i>
								</b-button>
							</b-col>
							<b-col v-if="reportsLoader" md="12" lg="12" class="d-flex justify-content-center">
								<b-spinner variant="primary" label="Spinning"></b-spinner>
							</b-col>
							<b-col v-if="!reportsLoader && attachments.length === 0" md="12" lg="12"
								   class="d-flex justify-content-center text-danger">
								<h6>No hay adjuntos, imagenes u otros disponibles</h6>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent/>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState, mapActions} from "vuex";

	export default {
		name: "VisitTicketDetail",
		components: {
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				loading: false,
				reportsLoader: false,
				visitTicket: '',
				reports: [],
				attachments: []
			}
		},
		mounted() {
			if (this.accountSelected !== '') {
				this.loading = true;
				this.reportsLoader = true;
				const visitTicketId = this.$route.params.id;

				this.getWorkProjectVisitTicketDetail(visitTicketId)
					.then((visitTicket) => {
						this.visitTicket = visitTicket;

						let data = {
							workProjectId: visitTicket.Id,
							workProjectName: visitTicket.Name
						}

						this.getWorkProjectVisitTicketAnnotations(data)
							.then((annotations) => {
								this.reports = annotations.reports;
								this.attachments = annotations.attachments;
							})
							.catch((err) => {
								console.log(err);
								this.reportsLoader = false;
							})
							.finally(() => {
								this.reportsLoader = false;
							})
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			...mapActions([
				'getWorkProjectVisitTicketDetail',
				'getWorkProjectVisitTicketAnnotations'
			]),
			downloadFile(file) {
				const linkSource = `data:application/pdf;base64,${file.DocumentBody}`;

				const downloadLink = document.createElement("a");

				downloadLink.href = linkSource;
				downloadLink.download = file.FileName;
				downloadLink.click();
			},
			downloadAttachment(file) {
				const linkSource = `data:application/jpeg;base64,${file.DocumentBody}`;

				const downloadLink = document.createElement("a");

				downloadLink.href = linkSource;
				downloadLink.download = file.FileName;
				downloadLink.click();
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected,
			})
		}
	}
</script>

<style scoped>

</style>
